let provider = null;
/** Called once at app bootstrap to wire the LLM configuration source. */
export function registerLlmConfigProvider(handler) {
    provider = handler;
}
export function getLlmConfigProvider() {
    if (!provider) {
        throw new Error('ai-assist: no LLM config provider registered — call registerLlmConfigProvider() at bootstrap');
    }
    return provider;
}
const SYSTEM_PROMPT = [
    "You are an editorial assistant for Denise Augusta's executive-support website.",
    'The brand voice is warm, precise, and professional — "calm in the chaos, precise in the details".',
    'Improve the text you are given: tighten the wording, keep the original meaning and rough length,',
    'and match the brand voice. Return ONLY the improved text — no preamble, no quotes, no markdown.',
].join(' ');
/**
 * Enhance a piece of site copy with Claude. Runs in the browser, so the
 * request carries the anthropic-dangerous-direct-browser-access header —
 * the API key comes from portal settings and never ships in the bundle.
 */
export async function enhanceWithClaude(text, context) {
    const config = await getLlmConfigProvider()();
    if (!config.apiKey) {
        throw new Error('No LLM API key configured — add one under Portal → Settings.');
    }
    const userMessage = context
        ? `Improve this text (it is ${context}):\n\n${text}`
        : `Improve this text:\n\n${text}`;
    const response = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'x-api-key': config.apiKey,
            'anthropic-version': '2023-06-01',
            'anthropic-dangerous-direct-browser-access': 'true',
        },
        body: JSON.stringify({
            model: config.model,
            max_tokens: 1024,
            system: SYSTEM_PROMPT,
            messages: [{ role: 'user', content: userMessage }],
        }),
    });
    if (!response.ok) {
        const detail = await response.text().catch(() => '');
        throw new Error(`Claude request failed (${response.status}): ${detail.slice(0, 200)}`);
    }
    const data = (await response.json());
    const enhanced = data.content
        .filter((block) => block.type === 'text' && block.text)
        .map((block) => block.text)
        .join('\n')
        .trim();
    if (!enhanced) {
        throw new Error('Claude returned no text');
    }
    return { enhanced, model: data.model };
}
//# sourceMappingURL=service.js.map